import { Form } from 'antd';
import { messages, placeHolders } from '../../../../../../constants';
import { CustomSelect } from '../../../../../uiComponents/CustomSelect';

const buildTreatmentLabel = (treatment, areas) => {
  const areasLabel = areas?.map((area) => area?.name).join(', ');
  return `${treatment?.name}${areasLabel ? ` - ${areasLabel}` : ''}`;
};

const buildTreatmentOptions = (treatmentPackage) => {
  return treatmentPackage?.map(({ treatment, areas }) => ({
    value: treatment?.id,
    label: buildTreatmentLabel(treatment, areas),
  }));
};

export const TreatmentSelect = ({ treatmentPackage }) => {
  return (
    <Form.Item
      label="Tratamiento"
      name="treatmentId"
      rules={[{ required: true, message: messages.required('Tratamiento') }]}
    >
      <CustomSelect
        placeholder={placeHolders.treatment}
        options={buildTreatmentOptions(treatmentPackage)}
      />
    </Form.Item>
  );
};
